import React, { useMemo, useState } from "react";
import { ChevronLeft, ChevronRight, TriangleAlert } from "lucide-react";

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function TeamCalendar({ inquiries }) {
  const [cursor, setCursor] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  });

  const byDate = useMemo(() => {
    const map = {};
    inquiries.forEach((inquiry) => {
      (map[inquiry.event_date] = map[inquiry.event_date] || []).push(inquiry);
    });
    return map;
  }, [inquiries]);

  const year = cursor.getFullYear();
  const month = cursor.getMonth();
  const firstWeekday = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const monthLabel = cursor.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  const todayIso = new Date().toISOString().slice(0, 10);
  const cells = [...Array(firstWeekday).fill(null), ...Array.from({ length: daysInMonth }, (_, index) => index + 1)];

  return (
    <div className="team-calendar" data-testid="team-calendar">
      <div className="calendar-head">
        <button type="button" className="text-button" onClick={() => setCursor(new Date(year, month - 1, 1))} data-testid="calendar-prev-month"><ChevronLeft size={16} /> Prev</button>
        <h2 data-testid="calendar-month-label">{monthLabel}</h2>
        <button type="button" className="text-button" onClick={() => setCursor(new Date(year, month + 1, 1))} data-testid="calendar-next-month">Next <ChevronRight size={16} /></button>
      </div>
      <div className="calendar-legend">
        <span><i className="dot dot-booked" /> Booked</span>
        <span><i className="dot dot-replied" /> Replied</span>
        <span><i className="dot dot-new" /> New enquiry</span>
        <span className="legend-warn"><TriangleAlert size={12} /> Date conflict</span>
      </div>
      <div className="calendar-grid calendar-weekdays">{WEEKDAYS.map((day) => <span key={day}>{day}</span>)}</div>
      <div className="calendar-grid">
        {cells.map((day, index) => {
          if (!day) return <div className="calendar-cell is-empty" key={`empty-${index}`} />;
          const iso = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
          const entries = byDate[iso] || [];
          const bookedCount = entries.filter((entry) => entry.status === "booked").length;
          const conflict = bookedCount > 1;
          return (
            <div className={`calendar-cell${iso === todayIso ? " is-today" : ""}${conflict ? " is-conflict" : ""}`} key={iso} data-testid={`calendar-day-${iso}`}>
              <span className="calendar-daynum">{day}{conflict && <TriangleAlert size={11} />}</span>
              {entries.map((entry) => (
                <span className={`calendar-event event-${entry.status}`} key={entry.id} title={`${entry.full_name} · ${entry.guest_count} guests · ${entry.status}`} data-testid={`calendar-event-${entry.id}`}>{entry.full_name}</span>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}
